<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('monthlyAttendence.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('monthlyAttendence.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <form class="form-horizontal">
          <div class="row">
            <div class="col-md-2 form-group">
              <label>{{ $t('cashCollectionByCashier.branchName') }}</label>
              <div>
                <a-select
                  v-model="model.branch_id"
                  :options="branchs"
                  showSearch
                  mode="multiple"
                  :filterOption="
                    (input, option) =>
                      option.componentOptions.children[0].text
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                  "
                  :maxTagCount="1"
                  :maxTagTextLength="17"
                  :placeholder="$t('all')"
                  style="width: 100%"
                >
                </a-select>
                <div class="validate" v-if="errors.has('branch_id')">
                  {{ errors.first('branch_id') }}
                </div>
              </div>
            </div>
            <div class="col-md-2 form-group">
              <label class="required">{{ $t('monthlyAttendence.date') }}</label>
              <div>
                <a-range-picker
                  style="width: 100%"
                  v-model="model.date_range"
                  format="DD-MM-YYYY"
                />
              </div>
            </div>

            <div class="col-md-2 form-group">
              <label>{{ $t('monthlyAttendence.department') }}</label>
              <div>
                <a-select
                  v-model="model.department_id"
                  :options="departments"
                  @change="onChangeDepartments"
                  showSearch
                  mode="multiple"
                  :filterOption="
                    (input, option) =>
                      option.componentOptions.children[0].text
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                  "
                  :maxTagCount="1"
                  :placeholder="$t('all')"
                  style="width: 100%"
                ></a-select>
              </div>
            </div>
            <div class="col-md-2 form-group">
              <label>{{ $t('monthlyAttendence.employeeName') }}</label>
              <a-select
                v-model="model.staff_id"
                :options="employees"
                @change="onChangeEmployee"
                :showSearch="true"
                mode="multiple"
                :filterOption="
                  (input, option) =>
                    option.componentOptions.children[0].text
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                "
                :maxTagCount="1"
                :placeholder="$t('all')"
                :maxTagTextLength="17"
                style="width: 100%"
              ></a-select>
            </div>
            <div class="col-md-2 form-group">
              <label>{{ $t('monthlyAttendence.position') }}</label>
              <div>
                <a-select
                  v-model="model.position_id"
                  :options="positions"
                  :showSearch="true"
                  mode="multiple"
                  :filterOption="
                    (input, option) =>
                      option.componentOptions.children[0].text
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                  "
                  :maxTagCount="1"
                  :placeholder="$t('all')"
                  style="width: 100%"
                >
                </a-select>
              </div>
            </div>

            <div class="mt-4">
              <ts-button
                class="ml-2 mr-2"
                outline
                color="success"
                :waiting="exporting"
                @click.prevent="exportExcel"
                >{{ $t('excel') }}</ts-button
              >
            </div>
            <div class="col-md-1 mt-4">
              <ts-button
                class="btn-block"
                color="primary"
                :waiting="waiting"
                @click="preview"
                >{{ $t('preview') }}</ts-button
              >
            </div>
          </div>
        </form>
      </ts-card-wrapper>
      <div id="inquiry-list">
        <ts-loading-banner :loading="fetchDataLoading">
          <div style="margin-top:-10px" class="ts-flex">
            <div class=" ts-flex ts-ml-2">
              <div class="box-al">
              </div>
              <p class="title">AL: Annual Leave</p>
            </div>
            <div class="ts-flex ts-ml-2">
              <div class="box-sl">
              </div>
              <p class="title">SL: Sick Leave</p>
            </div>
            <div class="ts-flex ts-ml-2">
              <div class="box-c">
              </div>
              <p class="title">CL: Compensation Leave</p>
            </div>
            <div class="ts-flex ts-ml-2">
              <div class="box-ml">
              </div>
              <p class="title">ML: Maternity Leave</p>
            </div>
            <div class="ts-flex ts-ml-2">
              <div class="box-u">
              </div>
              <p class="title">U: Unpaid Leave</p>
            </div>
            <div class="ts-flex ts-ml-2">
              <div class="box-el">
              </div>
              <p class="title">EL: Early Leave</p>
            </div>
            <div class="ts-flex ts-ml-2">
              <div class="box-a">
              </div>
              <p class="title">A: Absence</p>
            </div>
            
          </div>
          <ts-table :records="resources" class="ts-mt-3">
            <template v-slot:thead>
              <thead>
                <tr>
                  <th rowspan="2" class="ts-text-center">
                    {{ $t('monthlyAttendence.no') }}
                  </th>
                  <th rowspan="2">
                    {{ $t('monthlyAttendence.name') }}
                  </th>
                  <th rowspan="2">
                    {{ $t('monthlyAttendence.position') }}
                  </th>
                  <th rowspan="2" class="ts-text-center">
                    {{ $t('monthlyAttendence.totalAbsence') }}
                  </th>
                  <th rowspan="2" class="ts-text-center">
                    {{ $t('monthlyAttendence.totalLeave') }}
                  </th>
                  <th rowspan="2" class="color-y ts-text-center">
                    {{ $t('monthlyAttendence.al') }}
                  </th>
                  <th rowspan="2" class="ts-text-center color-bloue">
                    {{ $t('monthlyAttendence.sl') }}
                  </th>
                  <th rowspan="2" class="ts-text-center color-yb">
                    {{ $t('monthlyAttendence.cl') }}
                  </th>
                  <th rowspan="2" class="ts-text-center color-purple">
                    {{ $t('monthlyAttendence.ml') }}
                  </th>
                  <th rowspan="2" class="ts-text-center back-u">
                    {{ $t('monthlyAttendence.u') }}
                  </th>

                  <th rowspan="2" class="ts-text-center bg-color">
                    {{ $t('monthlyAttendence.el') }}
                  </th>
                  <th
                    class="ts-text-center"
                    v-for="(columns, index) in headers.date"
                    :key="index"
                    :value="columns"
                  >
                    {{ columns }}
                  </th>
                </tr>
                <tr>
                  <th
                    v-for="(columns, index) in dateString"
                    :key="index"
                    :value="columns"
                  >
                    {{ columns.substring(0, 3) }}
                  </th>
                </tr>
              </thead>
            </template>
            <template v-slot="{ record, index }">
              <td>{{ index + 1 }}</td>
              <td class="ts-whitespace-no-wrap">
                {{ record.name_en }}
              </td>
              <td class="ts-whitespace-no-wrap">
                {{ record.position ? record.position.pos_name_en : '' }}
              </td>
              <td class="ts-whitespace-no-wrap ts-text-center">
                {{ absentCount(record.employee_scan) }}
              </td>
              <td class="ts-whitespace-no-wrap ts-text-center">
                {{ totalLeave(record.employee_scan) }}
              </td>
              <td class="color-y ts-text-center ts-whitespace-no-wrap">
                {{ alCount(record.employee_scan) }}
              </td>
              <td class="ts-text-center color-bloue ts-whitespace-no-wrap">
                {{ slCount(record.employee_scan) }}
              </td>
              <td class="ts-text-center color-yb ts-whitespace-no-wrap">
                {{ cCount(record.employee_scan) }}
              </td>
              <td class="ts-text-center color-purple ts-whitspeace-no-wrap">
                {{ mlCount(record.employee_scan) }}
              </td>
              <td class="ts-text-center back-u ts-whitespace-no-wrap">
                {{ unpaidCount(record.employee_scan) }}
              </td>

              <td class="ts-text-center bg-color ts-whitespace-no-wrap">
                {{ elCount(record.employee_scan) }}
              </td>
              <td
                class="ts-text-center ts-whitespace-no-wrap"
                v-for="(dayNumber, date) in dateString"
                :key="date"
                :class="
                  coloring(
                    getStatusByDayNumberInMonth(record.employee_scan, date)
                  )
                "
              >
                {{ getStatusByDayNumberInMonth(record.employee_scan, date) }}
              </td>
            </template>
          </ts-table>
        </ts-loading-banner>
      </div>
      <div class="d-flex justify-content-between align-items-center p-15">
        <ts-total-list v-model="pagination" />
        <ts-pagination
          v-model="pagination"
          @navigate="fetchDataDetail"
        ></ts-pagination>
      </div>
    </ts-card>
  </div>
</template>
<script>
import { Errors } from 'form-backend-validation'
import { mapState, mapActions } from 'vuex'
import moment from 'moment'
import { sumBy, trim } from 'lodash'
import * as FileDownload from 'downloadjs'

export default {
  name: 'monthlyAttendence',

  data () {
    return {
      loading: false,
      fetchDataLoading: false,
      waiting: false,
      exporting: false,
      errors: new Errors(),
      branchs: [],
      departments: [],
      employees: [],
      positions: [],
      headers: [],
      dateString: [],
      holidays: [],
      model: {
        branch_id: [],
        department_id: [],
        staff_id: [],
        position_id: [],
        date_range: [moment(), moment()]
      }
    }
  },
  created () {
    this.branch_id = [this.$store.state.authUser.default_branch_id]
    this.getBranch()
    this.getDepartment()
    this.getEmployee()
    this.getHoliday()
  },
  computed: {
    ...mapState('monthlyAttendence', ['resources', 'pagination']),
    coloring: () => att => {
      let color = ''

      switch (att) {
        case 'A':
          color = 'color color-red'
          break
        case 'P':
          color = 'color color-primary'
          break

        case 'AL: 1':
          color = 'color color-y'
          break
        case 'AL: 0.5':
          color = 'color color-y'
          break
        case 'ML: ':
          color = 'color color-purple'
          break
        case 'ML: 0.5':
          color = 'color color-purple'
          break
        case 'SL: 1':
          color = 'color color-bloue'
          break
        case 'SL: 0.5':
          color = 'color color-bloue'
          break
        case 'EL: 1':
          color = 'color bg-color'
          break
        case 'EL: 0.5':
          color = 'color bg-color'
          break
        case 'U: 1':
          color = 'color back-u'
          break
        case 'U: 0.5':
          color = 'color back-u'
          break
        case 'SPL: 1':
          color = 'color color-bloue'
          break
        case 'SPL: 0.5':
          color = 'color color-bloue'
          break
        case 'PH':
          color = 'color ph'
          break
        case 'x':
          color = 'color color-black'
          break
      }
      return color
    },

    unpaidCount: () => attRecord => {
      if (attRecord) {
        const al = attRecord.filter(a => a.leave_type === 'Unpaid Leave')
        return sumBy(al, 'total_leave_day')
      }
    },
    alCount: () => attRecord => {
      if (attRecord) {
        const al = attRecord.filter(a => a.leave_type === 'Annual Leave')
        return sumBy(al, 'total_leave_day')
      }
    },
    slCount: () => attRecord => {
      if (attRecord) {
        const al = attRecord.filter(a => a.leave_type === 'Sick Leave')
        return sumBy(al, 'total_leave_day')
      }
    },
    elCount: () => attRecord => {
      if (attRecord) {
        const al = attRecord.filter(a => a.leave_type === 'Early leave')
        return sumBy(al, 'total_leave_day')
      }
    },
    cCount: () => attRecord => {
      if (attRecord) {
        const al = attRecord.filter(a => a.leave_type === 'Compensation Leave')
        return sumBy(al, 'total_leave_day')
      }
    },
    mlCount: () => attRecord => {
      if (attRecord) {
        const al = attRecord.filter(a => a.leave_type === 'Maternity Leave')
        return sumBy(al, 'total_leave_day')
      }
    },
    absentCount: () => attRecord => {
      if (attRecord) {
        return attRecord.filter(a => a.att_status === 'Absent').length
      }
      return 0
    },
    totalLeave: () => attRecord => {
      if (attRecord) {
        const al = attRecord.filter(a => a.att_status === 'Leave')
        return sumBy(al, 'total_leave_day')
      }
    },
    getStatusByDayNumberInMonth: vm => (scanData, date) => {
      const dayNumber = moment(date, 'DD-MM-YYYY').format('DD')
      const findHolidayByDate = vm.holidays.find(s => {
        let scanDay = moment(s.hol_date, 'DD-MM-YYYY').format('DD')
        return parseInt(scanDay) == parseInt(dayNumber)
      })
      if (scanData !== null) {
        const findDay = scanData.find(s => {
          let scanDay = moment(s.att_date, 'DD-MM-YYYY').format('DD')
          return parseInt(scanDay) == parseInt(dayNumber)
        })
        if (findDay) {
          if (findDay.att_status) {
            switch (findDay.att_status) {
              case 'Present':
                return 'P'
              case 'Absent':
                return 'A'
            }
          }
          if (findDay.leave_type) {
            switch (findDay.leave_type) {
              case 'Annual Leave':
                if (findDay.total_leave_day == '0.5') {
                  return 'AL: ' + findDay.total_leave_day
                } else return 'AL: 1'
              case 'Maternity Leave':
                if (findDay.total_leave_day == '0.5') {
                  return 'ML: ' + findDay.total_leave_day
                } else return 'ML: 1'
              case 'Sick Leave':
                if (findDay.total_leave_day == '0.5') {
                  return 'SL: ' + findDay.total_leave_day
                } else return 'SL: 1'
              case 'Early leave':
                if (findDay.total_leave_day == '0.5') {
                  return 'EL: ' + findDay.total_leave_day
                } else return 'EL: 1'
              case 'Unpaid Leave':
                if (findDay.total_leave_day == '0.5') {
                  return 'U: ' + findDay.total_leave_day
                } else return 'U: 1'
              case 'Special Leave':
                if (findDay.totalLeave == '0.5') {
                  return 'SPL: ' + findDay.total_leave_day
                } else return 'SPL: 1'
            }
          }
        }
        if (findHolidayByDate) {
          if (findHolidayByDate.hol_date) {
            return 'PH'
          }
        }
        return 'x'
      }
    }
  },
  methods: {
    ...mapActions('monthlyAttendence', ['getEmployee', 'getPosition']),

    getBranch () {
      this.$store
        .dispatch('user/getBranch', {
          filter: {
            user_branches: true
          }
        })
        .then(response => {
          this.branchs = response.data.map(el => ({
            value: el.branch_id,
            label: el.branch_name_en
          }))
        })
    },
    getDepartment () {
      this.$store.dispatch('monthlyAttendence/getDepartment').then(response => {
        this.departments = response.data.map(el => ({
          value: el.department_id,
          label: el.department_name_en
        }))
      })
    },
    getHoliday () {
      this.holidays.length = 0
      this.$store
        .dispatch(
          'monthlyAttendence/getHoliday',
          Object.assign({}, this.model, {
            branch_id: this.branch_id,
            department_id: this.model.department_id,
            date_range: [
              this.model.date_range[0].format('DD-MM-YYYY'),
              this.model.date_range[1].format('DD-MM-YYYY')
            ]
          })
        )
        .then(res => {
          this.holidays = res.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => (this.loading = false))
    },
    onChangeDepartments () {
      this.model.staff_id = []
      this.getEmployee({
        filter: {
          department_id: this.model.department_id
        }
      }).then(response => {
        this.employees = response.data.map(el => ({
          value: el.staff_id,
          label: el.name_en + '|' + el.name_kh
        }))
      })
    },
    onChangeEmployee () {
      this.model.position_id = []
      this.getPosition({
        filter: {
          staff_id: this.model.staff_id
        }
      }).then(response => {
        this.positions = response.data.map(el => ({
          value: el.position_id,
          label: el.pos_name_en
        }))
      })
    },
    fetchDataDetail (attributes) {
      this.fetchDataLoading = true
      this.error = new Errors()
      this.$store
        .dispatch(
          'monthlyAttendence/fetch',
          Object.assign(
            {},
            this.model,
            {
              branch_id: this.branch_id,
              department_id: this.model.department_id,
              date_range: [
                this.model.date_range[0].format('DD-MM-YYYY'),
                this.model.date_range[1].format('DD-MM-YYYY')
              ]
            },
            attributes
          )
        )
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => (this.fetchDataLoading = false))
    },
    cycleMonthChange (value) {
      this.model.att_date = value
    },
    preview (attributes) {
      this.waiting = true
      this.errors = new Errors()
      this.$store
        .dispatch(
          'monthlyAttendence/getHeader',
          Object.assign(
            {},
            this.model,
            {
              branch_id: this.branch_id,
              department_id: this.model.department_id,
              date_range: [
                this.model.date_range[0].format('DD-MM-YYYY'),
                this.model.date_range[1].format('DD-MM-YYYY')
              ]
            },
            attributes
          )
        )
        .then(response => {
          this.dateString = response['dateString']
          this.headers = response['columnHeaders']
          this.fetchDataDetail()
          this.getHoliday()
          this.loading = false
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    exportExcel () {
      this.exporting = true
      this.errors = new Errors()
      this.$store
        .dispatch(
          'monthlyAttendence/exportExcel',
          Object.assign({}, this.model, {
            branch_id: this.branch_id,
            department_id: this.model.department_id,
            date_range: [
              this.model.date_range[0].format('DD-MM-YYYY'),
              this.model.date_range[1].format('DD-MM-YYYY')
            ]
          })
        )
        .then(response => {
          let filename = trim(
            response.headers['content-disposition']
              .substring(
                response.headers['content-disposition'].indexOf('filename')
              )
              .replace('filename=', ''),
            '"'
          )
          FileDownload(response.data, filename)
        })
        .catch(err => {
          let error = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(err))
          )
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => (this.exporting = false))
    }
  }
}
</script>
<style scoped>
.no-padding-top {
  padding: 0 1rem 1rem 1rem;
}
#table-container {
  min-height: 30vh;
  overflow-y: scroll;
  
}
table > tbody > tr td {
  vertical-align: middle;
}

.table > thead > tr > th {
  border: 1px solid #b6c2c9;
  vertical-align: middle;
}
::-webkit-scrollbar {
  height: 8px;
  width: 3px; /* Remove scrollbar space */
  background: #ffff; /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: #e5e7e7;
}
div::-webkit-scrollbar-thumb:hover {
  background: #b7b7b8;
}
#inquiry-list {
  max-height: 60vh;
  overflow: scroll;
}
.color-y {
  background-color: #f7dc6f;
}
.color-bloue {
  background-color: #8fcae0;
}
.color-yb {
  background-color: #dade9b;
}
.color-purple {
  background-color: #d7bde2;
}
.color-red {
  background-color: #e84641;
}
.color-greend {
  background-color: #7bf57b;
}
.bg-color {
  background-color: #a9d070;
}
.color-black {
  background-color: #bcc7c7;
}
.back-u {
  background-color: #e0f9f3;
}
.ph {
  background-color: #e84641;
}
.box-al {
  width: 27px;
  height: 22px;
  background-color: #f7dc6f;
  border: 1px solid #f7dc6f;
  padding: 3px;
  margin: 10px;
  box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.1);
  border-radius: 2px 2px 2px 2px ;
}
.box-sl {
  width: 27px;
  height: 22px;
  background-color: #8fcae0;
  border: 1px solid #8fcae0;
  padding: 3px;
  margin: 10px;
  box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.1);
  border-radius: 2px 2px 2px 2px ;
}
.box-c {
  width: 27px;
  height: 22px;
  background-color: #dade9b;
  border: 1px solid #dade9b;
  padding: 3px;
  margin: 10px;
  box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.1);
  border-radius: 2px 2px 2px 2px ;
}
.box-ml {
  width: 27px;
  height: 22px;
  background-color: #d7bde2;
  border: 1px solid #d7bde2;
  padding: 3px;
  margin: 10px;
  box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.1);
  border-radius: 2px 2px 2px 2px ;
}
.box-u {
  width: 27px;
  height: 22px;
  background-color: #e0f9f3;
  border: 1px solid #e0f9f3;
  padding: 3px;
  margin: 10px;
  box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.1);
  border-radius: 2px 2px 2px 2px ;
}
.box-el {
  width: 27px;
  height: 22px;
  background-color: #7bf57b;
  border: 1px solid #7bf57b;
  padding: 3px;
  margin: 10px;
  box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.1);
  border-radius: 2px 2px 2px 2px ;
}
.box-a {
  width: 27px;
  height: 22px;
  background-color: red;
  border: 1px solid red;
  padding: 3px;
  margin: 10px;
  box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.1);
  border-radius: 2px 2px 2px 2px ;
}
.title{
  margin-top:14.8px;

}
</style>
